import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';
import { getTranslatedString } from 'helpers/i18n';

const { Option } = Select;

const StyledSelect = styled(Select)`
  .ant-select {
    width: 100% !important;
  }
`;

class MultiSelectDropDown extends React.Component {
  render() {
    return (
      <StyledSelect
        mode="multiple"
        placeholder={getTranslatedString('multiSelectDropDown.placeholder')}
        defaultValue={['a10', 'c12']}
        dropdownMatchSelectWidth
        {...this.props}
      >
        {this.props.data.map(option => {
          return (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          );
        })}
      </StyledSelect>
    );
  }
}

export default MultiSelectDropDown;
